import React from 'react'

function Services() {
    return (
        <div>
            <h1 className="page-title">SERVICES</h1>
        </div>
    )
}

export default Services
